import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { API_URL, formatDate, getStatusBadgeClass } from '../lib/utils';
import { toast } from 'sonner';
import {
  Briefcase,
  Users,
  FileText,
  Loader2,
  Building2,
  UserCheck,
  TrendingUp,
  DollarSign,
  Settings,
  CreditCard,
  Shield,
  Upload,
  Rss,
  FileSpreadsheet,
  Download,
  CheckCircle2,
  AlertCircle,
  BarChart3,
  Mail,
  MessageSquare,
  MousePointerClick,
  Calendar,
  ArrowUpRight,
  ArrowDownRight,
  Send,
  Clock,
  BadgeCheck,
  ExternalLink,
  XCircle,
  MapPin,
  Bell,
  Eye,
} from 'lucide-react';
import { useAdminCtx } from './AdminContext';


const AdminTabSubscriptions = () => {
  const { subscriptions } = useAdminCtx();
  return (
    <>
            <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Plan</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscriptions.map((sub) => (
                      <tr key={sub.subscription_id}>
                        <td className="font-medium">{sub.user_id}</td>
                        <td>{sub.plan_name}</td>
                        <td>${sub.amount}</td>
                        <td>
                          <Badge className={getStatusBadgeClass(sub.status)}>
                            {sub.status}
                          </Badge>
                        </td>
                        <td>{formatDate(sub.start_date)}</td>
                        <td>{formatDate(sub.end_date)}</td>
                      </tr>
                    ))}
                    {subscriptions.length === 0 && (
                      <tr>
                        <td colSpan={6} className="text-center py-8 text-gray-500">
                          No subscriptions yet
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
    </>
  );
};

export default AdminTabSubscriptions;
